import { css } from "styled-components";

const FlexCenter = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const FlexCenterBetween = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export { FlexCenter, FlexCenterBetween };
